<template>
  <div class="ic-breadcrumb">
    <nav style="" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Strona główna </a></li>
        <li class="breadcrumb-item"><a href="#">Aktualności</a></li>
        <li class="breadcrumb-item active" aria-current="page">Flota PKP Intercity bogatsza o</li>
      </ol>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'section-breadcrumb',
  data() {
    return {}
  }
}
</script>